// @core/api/endpoints/billing/create_price.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePriceRequest,
  CreatePriceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create price for product
 * Creates a new price for a product with specified billing period and pricing model. Supports flat-rate, tiered, and usage-based pricing.
 */
export async function CreatePrice(
  productId: string,
  data: CreatePriceRequest,
  options?: RequestOptions
): Promise<CreatePriceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:productId/prices`;
  requestPath = requestPath.replace(':productId', encodeURIComponent(productId));
  const requestOptions = options;
  return client.post<CreatePriceResponse>(requestPath, data, requestOptions);
}
